

export default function Reports() {
  const summary = {
    totalRevenue: "£25,000",
    totalCommission: "£3,200",
    totalContracts: 42,
    activeAgents: 6,
  };

  const monthlyData = [
    {
      month: "Jan 2026",
      revenue: "£5,000",
      commission: "£600",
      contracts: 8,
    },
    {
      month: "Feb 2026",
      revenue: "£8,000",
      commission: "£1,000",
      contracts: 12,
    },
    {
      month: "Mar 2026",
      revenue: "£12,000",
      commission: "£1,600",
      contracts: 22,
    },
  ];

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      
      {/* TITLE */}
      <h1 className="text-2xl font-semibold mb-6">Reports</h1>

      {/* SUMMARY CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
        
        <Card title="Total Revenue" value={summary.totalRevenue} />
        <Card title="Total Commission" value={summary.totalCommission} />
        <Card title="Total Contracts" value={summary.totalContracts} />
        <Card title="Active Agents" value={summary.activeAgents} />

      </div>

      {/* MONTHLY TABLE */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <div className="p-4 border-b font-semibold">
          Monthly Performance
        </div>

        <table className="w-full text-left">
          <thead className="bg-gray-50 text-gray-600 text-sm">
            <tr>
              <th className="p-4">Month</th>
              <th>Revenue</th>
              <th>Commission</th>
              <th>Contracts</th>
            </tr>
          </thead>

          <tbody>
            {monthlyData.map((row, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="p-4">{row.month}</td>
                <td>{row.revenue}</td>
                <td>{row.commission}</td>
                <td>{row.contracts}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* CARD COMPONENT */
function Card({ title, value }) {
  return (
    <div className="bg-white p-4 rounded-xl shadow">
      <p className="text-sm text-gray-500">{title}</p>
      <h2 className="text-xl font-semibold mt-2">{value}</h2>
    </div>
  );
}